import { useMutation, useQueryClient } from "@tanstack/react-query"
import { toast } from "react-toastify";

import { createOption } from "../../services/option";
import { IIndicators } from "../../types/indicator";

const useCreateOption = (indicator: IIndicators) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: createOption,
        onMutate: () => {
            indicator.setIsProcessRunning(true);
            indicator.setIsServiceError(null);
        },
        onSuccess: (status) => {
            if (status === 200) {
                queryClient.invalidateQueries({ queryKey: ['question-options'] });
                indicator.setIsProcessRunning(false);
                toast.success("Action created successfully!");
            }
        },

        onError: (error: any) => {
            indicator.setIsProcessRunning(false);
            indicator.setIsServiceError(error.response?.data?.message);
            toast.error(error.response?.data?.message);
        }
    });
};

export default useCreateOption;